import { Component, OnInit } from '@angular/core';
import { forkJoin, Observable } from "rxjs";
import { DestroyBase } from '../../../components/common/ng-destroy-base';
import { RefListModel } from '../../../models/ref-list-model';
import { LocalizationNavigationService } from '../services/localization-navigation-service';
import { LocalizationService } from '../services/localization-service';

/**
 * Handles localization host component
 */
@Component({
  selector: 'localization-host',
  templateUrl: './localization-host.component.html'
})
export class LocalizationHostComponent extends DestroyBase implements OnInit {
  /**
   * CurrencyFormat reflist
   */
  currencyFormatRefList: RefListModel[] = [];

  /**
   * Constructor
   * @param localizationService LocalizationService
   */
  constructor(protected localizationService: LocalizationService,
    private localizationNavigationService: LocalizationNavigationService) {
    super();
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.localizationNavigationService.onTemplateSelected(false);
  }

  /**
   * The edit form id
   */
  public editFormId$ = this.localizationService.editFormId$;

  /**
  * Load the ref lists
  */
  private requestRefLists(): Observable<any[]> {
    const currencyFormatRefList = this.localizationService.getRefList('ref_l3_currency_format');

    return forkJoin([currencyFormatRefList]);
  }

  /**
   * Load the ref lists
   */
  protected loadReflists(): Promise<void> {
    return new Promise((resolve, _reject) => {
      this.subscriptions.add(this.requestRefLists().subscribe(responseList => {
        this.currencyFormatRefList = responseList[0];

        resolve();
      }));
    });
  }
}
